import gql from 'graphql-tag';

export default gql`
  query getCustomRedirects($groupId: Int!) {
    custom_redirects(where: { group_id: { _eq: $groupId } }, order_by: { from_path: asc }) {
      id
      from_path
      to_path
      permanent
      status
    }
  }
`;
